// extracted by mini-css-extract-plugin
export default {"priceContainer":"o_-z","discountedPrice":"p_-z","originalPrice":"q_-z","productPrice":"r_-z"};